import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import { titleCaseWord } from '../util';
import LetterFilterMenu from './LetterFilterMenu';
import LetterCombinationsFilterMenu from './LetterCombinationsFilterMenu';
import ShapeFilterMenu from './ShapeFilterMenu';
import ClipartFilterMenu from './ClipartFilterMenu';

import filterBtnImg from '../images/btn-filter.svg';

class ProductHeader extends Component {
  state = {
    letterFilterMenuOpen: false,
    letterCombinationsFilterMenuOpen: false,
    shapeFilterMenuOpen: false,
    clipartFilterMenuOpen: false,
    filterMenuAnchorEl: null,
  };

  getStepName() {
    const { activeStep } = this.props;
    let stepName = activeStep;

    if (activeStep === 'BANNERS') {
      stepName = 'Whiteboards';
    } else if (activeStep === 'LETTERS') {
      stepName = 'Letters';
    } else if (activeStep === 'LETTER_COMBINATIONS') {
      stepName = 'Letter Combinations';
    } else if (activeStep === 'SHAPES') {
      stepName = 'Shapes';
    } else if (activeStep === 'CLIPART') {
      stepName = 'Clipart';
    }

    return stepName;
  }

  formatLabel(value) {
    return value
      .toLowerCase()
      .split('_')
      .map(titleCaseWord)
      .join(' ');
  }

  getStepFilters() {
    const filters = this.props.filters;
    const activeStep = this.props.activeStep;
    let activeStepFilters = [];

    const makeFilterObj = (product, attr, value, label = `${value}`) => {
      return {
        product,
        attr,
        value,
        label: this.formatLabel(label),
      };
    };

    if (activeStep === 'LETTERS') {
      const fontStyleFilters = filters.letters.fontStyle.map(fontStyle =>
        makeFilterObj('letters', 'fontStyle', fontStyle),
      );

      activeStepFilters = activeStepFilters.concat(fontStyleFilters);
    } else if (activeStep === 'LETTER_COMBINATIONS') {
      const patternFilters = filters.letterCombinations.pattern.map(pattern =>
        makeFilterObj('letterCombinations', 'pattern', pattern),
      );

      activeStepFilters = activeStepFilters.concat(patternFilters);
    } else if (activeStep === 'SHAPES') {
      const typeFilters = filters.shapes.type.map(type =>
        makeFilterObj('shapes', 'type', type),
      );

      activeStepFilters = activeStepFilters.concat(typeFilters);
    } else if (activeStep === 'CLIPART') {
      const categoryFilters = filters.clipart.category.map(category =>
        makeFilterObj('clipart', 'category', category),
      );

      activeStepFilters = activeStepFilters.concat(categoryFilters);
    }

    return activeStepFilters;
  }

  handleClickFilter = (...args) => {
    const activeStep = this.props.activeStep;

    if (activeStep === 'LETTERS') {
      this.handleClickLetterFilter(...args);
    } else if (activeStep === 'LETTER_COMBINATIONS') {
      this.handleClickLetterCombinationsFilter(...args);
    } else if (activeStep === 'SHAPES') {
      this.handleClickShapeFilter(...args);
    } else if (activeStep === 'CLIPART') {
      this.handleClickClipartFilter(...args);
    }
  };

  // Letters
  handleClickLetterFilter(event) {
    this.setState({
      letterFilterMenuOpen: true,
      filterMenuAnchorEl: event.currentTarget,
    });
  }

  handleClickFilterLetterFontStyle = (fontStyle) => {
    this.setState({
      letterFilterMenuOpen: false,
    });

    this.props.setFilter("letters", "fontStyle", [fontStyle])
  };

  // Letter Combinations
  handleClickLetterCombinationsFilter(event) {
    this.setState({
      letterCombinationsFilterMenuOpen: true,
      filterMenuAnchorEl: event.currentTarget,
    });
  }

  handleClickFilterLetterCombinationsPattern = (pattern) => {
    this.setState({
      letterCombinationsFilterMenuOpen: false,
    });

    this.props.setFilter("letterCombinations", "pattern", [pattern])
  };

  // Shapes
  handleClickShapeFilter(event) {
    this.setState({
      shapeFilterMenuOpen: true,
      filterMenuAnchorEl: event.currentTarget,
    });
  }

  handleClickFilterShapeType = (type) => {
    this.setState({
      shapeFilterMenuOpen: false,
    });

    this.props.setFilter('shapes', 'type', [type]);
  };

  // Clipart
  handleClickClipartFilter(event) {
    this.setState({
      clipartFilterMenuOpen: true,
      filterMenuAnchorEl: event.currentTarget,
    });
  }

  handleClickFilterClipartCategory = (category) => {
    this.setState({
      clipartFilterMenuOpen: false,
    });

    this.props.setFilter('clipart', 'category', [category]);
  }

  renderStepFilter = (filter, key) => {
    return (
      <div className="product-header-filter" key={key}>
        <Chip onDelete={() => this.props.removeFilter(filter)} label={filter.label} />
      </div>
    );
  }

  render() {
    const stepName = this.getStepName();
    const stepFilters = this.getStepFilters();

    return (
      <div className="product-header">
        <h3 className="product-header-title">{stepName}</h3>
        <div className="product-header-filters">
          {stepFilters.map(this.renderStepFilter)}
          {this.props.activeStep !== 'BANNERS' && (
            <img
              className="product-header-filter-btn"
              src={filterBtnImg}
              alt="filter"
              onClick={this.handleClickFilter}
            />
          )}
        </div>

        <LetterFilterMenu
          open={this.state.letterFilterMenuOpen}
          anchorEl={this.state.filterMenuAnchorEl}
          handleRequestClose={() => this.setState({ letterFilterMenuOpen: false })}
          handleClickFilterLetterFontStyle={this.handleClickFilterLetterFontStyle}
        />
        <LetterCombinationsFilterMenu
          open={this.state.letterCombinationsFilterMenuOpen}
          anchorEl={this.state.filterMenuAnchorEl}
          handleRequestClose={() => this.setState({ letterCombinationsFilterMenuOpen: false })}
          handleClickFilterLetterCombinationsPattern={this.handleClickFilterLetterCombinationsPattern}
        />
        <ShapeFilterMenu
          open={this.state.shapeFilterMenuOpen}
          anchorEl={this.state.filterMenuAnchorEl}
          handleRequestClose={() => this.setState({ shapeFilterMenuOpen: false })}
          handleClickFilterShapeType={this.handleClickFilterShapeType}
        />
        <ClipartFilterMenu
          open={this.state.clipartFilterMenuOpen}
          anchorEl={this.state.filterMenuAnchorEl}
          handleRequestClose={() => this.setState({ clipartFilterMenuOpen: false })}
          handleClickFilterClipartCategory={this.handleClickFilterClipartCategory}
        />
      </div>
    );
  }
}

ProductHeader.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  activeStep: PropTypes.string.isRequired,
};

export default ProductHeader;
